import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  onIsWaiting = new EventEmitter<boolean>();
}
